import { Theme, createStyles } from "@material-ui/core";
import { COLORS } from "../../config/theme/baseTheme";

export const useColorStyles = (theme: Theme) =>
  createStyles({
    "&.INFO_BLUE": {
      backgroundColor: COLORS.INFO_BLUE,
    },
    "&.READY_BLUE": {
      backgroundColor: COLORS.READY_BLUE,
    },
    "&.MINSK": {
      backgroundColor: COLORS.MINSK,
    },
    "&.PRIMARY_BLUE": {
      backgroundColor: COLORS.PRIMARY_MAIN,
    },
    "&.JUNGLE_GREEN": {
      backgroundColor: COLORS.JUNGLE_GREEN,
    },
    "&.PARTIAL_SUCCESS_GREEN": {
      backgroundColor: COLORS.PARTIAL_SUCCESS_GREEN,
    },
    "&.ERROR_RED": {
      backgroundColor: COLORS.PALE_RED,
    },
    "&.PALE_GRAY": {
      backgroundColor: COLORS.PALE_GRAY,
    },
    "&.ALERT_ORANGE": {
      backgroundColor: COLORS.ALERT_ORANGE,
    },
    "&.PICTON_BLUE": {
      backgroundColor: COLORS.PICTON_BLUE,
    },
    "&.CREAM_CAN": {
      backgroundColor: COLORS.CREAM_CAN,
    },
    "&.VISTA_BLUE": {
      backgroundColor: COLORS.VISTA_BLUE,
    },
    "&.SEA_GREEN": {
      backgroundColor: COLORS.SEA_GREEN,
    },
    "&.GOLDEN_BELL": {
      backgroundColor: COLORS.GOLDEN_BELL,
    },
    "&.SCAMPI": {
      backgroundColor: COLORS.SCAMPI,
    },
    "&.BLUE": {
      backgroundColor: COLORS.PRIMARY_MAIN,
    },
    "&.SEA_GREEN2": {
      backgroundColor: COLORS.SEA_GREEN2,
    },
    "&.LUCKY": {
      backgroundColor: COLORS.LUCKY,
    },
    "&.DUSTY_GRAY": {
      backgroundColor: COLORS.DUSTY_GRAY,
    },
    "&.BLACK": {
      backgroundColor: COLORS.BLACK,
    },
    "&.AMBER": {
      backgroundColor: COLORS.AMBER,
    },
    "&.RED": {
      backgroundColor: COLORS.PALE_RED,
    },
    "&.MADISON_BLUE": {
      backgroundColor: COLORS.GREEN_BLUE,
    },
    '&.EMRALD': {
      backgroundColor: COLORS.EMRALD,
    },
  });